import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

const STATUS = {
    green: { label: "healthy",   dot: "bg-emerald-400",   ring: "border-emerald-400/40", text: "text-emerald-300" },
    amber: { label: "degraded",  dot: "bg-amber-400",     ring: "border-amber-400/40",   text: "text-amber-300"   },
    red:   { label: "failing",   dot: "bg-rose-400",      ring: "border-rose-400/40",    text: "text-rose-300"    },
    idle:  { label: "no traffic",dot: "bg-[#6e6a62]",     ring: "border-white/10",       text: "text-[#9a958a]"   },
};

/**
 * Tiny 24h handoff-health pill. Lives in the admin sub-nav so the Curator
 * sees Hub-integration health at a glance, on every admin page, without
 * having to drill into the Handoff tab.
 */
export default function HandoffHealthBadge() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/admin/handoff-health")
            .then(({ data }) => setData(data.last24h))
            .catch(() => setData(null));
    }, []);

    if (!data) return null;
    const s = STATUS[data.status] || STATUS.idle;
    const title =
        data.status === "idle"
            ? "No handoff traffic in the last 24h."
            : `Last 24h · ${data.total} attempt${data.total === 1 ? "" : "s"} · ${data.failures} failure${data.failures === 1 ? "" : "s"}.`;

    return (
        <Link
            to="/admin/handoff"
            title={title}
            className={`ml-auto inline-flex items-center gap-2 rounded-full border ${s.ring} bg-white/[0.02] px-3 py-1 transition-colors hover:bg-white/[0.05]`}
            data-testid="handoff-health-badge"
        >
            <span className={`relative flex h-2 w-2`} aria-hidden>
                {data.status === "red" && (
                    <span className={`absolute inline-flex h-full w-full animate-ping rounded-full ${s.dot} opacity-60`} />
                )}
                <span className={`relative inline-flex h-2 w-2 rounded-full ${s.dot}`} />
            </span>
            <span className="font-label text-[10px] tracking-[0.25em] uppercase text-[#9a958a]">
                Hub link
            </span>
            <span
                className={`font-label text-[10px] tracking-[0.25em] uppercase ${s.text}`}
                data-testid="handoff-health-status"
            >
                {s.label}
            </span>
            {data.total > 0 && (
                <span className="font-label text-[10px] tracking-[0.25em] uppercase text-[#6e6a62]">
                    · 24h {data.failures}/{data.total}
                </span>
            )}
        </Link>
    );
}
